
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { countryCodePage, deleteCountryCode } from "@/api/api-basic";
import addCountryCode from "./components/add.vue";
import { State } from "vuex-class";
import i18n from "@/config/i18n";
@Component({
  components: {
    "add-country-code": addCountryCode
  }
})
export default class SystemConfigRole extends Vue {
  @State("sys") sys!: objAny;
  private total = 0;
  private privilege: objAny = {};
  private loading = false;
  private selectRolePkId = "";
  private formInline: objAny = {
    globalOrderBy: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private addModalTitle = "";
  private addModalShow = false;
  private autoModalTitle = i18n.t("role.autoConfig");
  private autoModalShow = false;

  private tableH = 0;
  private roleTypeList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    // {
    //   type: "selection",
    //   width: 60,
    //   align: "center"
    // },
    {
      title: i18n.t("countrycode.areaCode"),
      key: "countryCode",
      width: 100
    },
    {
      title: i18n.t("countrycode.enName"),
      key: "englishCodeName",
      minWidth: 120
    },
    {
      title: i18n.t("countrycode.zhName"),
      key: "chineseCodeName",
      minWidth: 120
    },
    {
      title: i18n.t("countrycode.locName"),
      key: "localLanguageCodeName",
      minWidth: 120
    },
    {
      title: i18n.t("countrycode.regRules"),
      key: "regularExpression",
      minWidth: 120
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      width: 140
    }
  ];

  private addCountryCode: objAny = {};
  private permission: objAny = {};

  public addUserSuccess() {
    this.addModalShow = false;
    this.getTableList();
  }

  public updataClick(item: objAny) {
    this.addModalTitle = item.pkId
      ? i18n.t("countrycode.edit") + ""
      : i18n.t("countrycode.add") + "";
    this.addModalShow = true;
    this.$nextTick(() => {
      this.addCountryCode.initData(item);
    });
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    if (this.formInline.roleType == undefined) {
      this.formInline.roleType = "";
    }
    const ret = await countryCodePage(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data || [];
    }
    this.loading = false;
  }

  async delCode(pkId: string): Promise<void> {
    const ret = await deleteCountryCode({ pkId });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess") + "");
      this.getTableList();
    }
  }

  mounted() {
    this.$nextTick(() => {
      this.tableH = this.$refs.tableBox.offsetHeight || 300;
      this.addCountryCode = this.$refs["addCountryCode"];
    });
    this.privilege = this.$route.meta.privilegeVoObj;
    this.getTableList();
  }
}
